import React from 'react';
import { Tabs } from '@alvogen/shared/components/tabs/Tabs';
import { Documents } from 'components/documents/Documents';
import { DocumentsItem } from 'components/documents/DocumentsItem';
import { Documents as NewDocuments } from '@alvogen/shared/components/documents/Documents';

export const DocumentsSlice = ({
  appearance,
  title,
  items,
  slice,
  trailing,
  isSlice,
  isSplitPage,
  isArticle,
}) => {
  if (appearance) {
    return (
      <Tabs
        tabs={[slice, ...trailing].map(({ title, items }, i) => {
          return {
            title,
            content: (
              <NewDocuments tab key={i}>
                {items?.map((item, index) => (
                  <NewDocuments.Item key={index} link={item.link} title={item.title} />
                ))}
              </NewDocuments>
            ),
          };
        })}
      />
    );
  }

  return (
    <Documents isSlice={isSlice} isSplitPage={isSplitPage} isArticle={isArticle}>
      {items?.map((item, key) => (
        <DocumentsItem
          key={key}
          single={items.length === 1}
          title={item.title}
          link={item.link}
          filename={item.filename}
          filetype={item.filetype}
          filesize={item.filesize}
        />
      ))}
    </Documents>
  );
};

export default DocumentsSlice;
